import Vue, { VueConstructor } from 'vue';

interface HTMLElementWithHandler extends HTMLElement {
    hash: string;
    href: string;
    __vueLinkHash__?: () => void;
}

const LinkHash = {
    install (Vue: VueConstructor<Vue>) {
        Vue.directive('link-hash', {
            bind: function (element: HTMLElement) {
                const handler = () => {
                    (<HTMLElementWithHandler>element).hash = '';
                    (<HTMLElementWithHandler>element).href += location.hash || '';
                };
                (<HTMLElementWithHandler>element).__vueLinkHash__ = handler;

                // add Event Listeners
                window.addEventListener('hashchange', handler);
                window.addEventListener('load', handler);
            },
            unbind: function (element: HTMLElement) {
                // Remove Event Listeners
                const handler = (<HTMLElementWithHandler>element).__vueLinkHash__;

                if (handler) {
                    window.addEventListener('hashchange', handler);
                    window.addEventListener('load', handler);
                }
            },
        });
    },
};

export default LinkHash;
